import { useEffect, useState } from 'react'
import { getSignedURLSByPath } from '../signed-url.service'

export const useSignedURL = (src?: string): { url: string; isLoading: boolean } => {
    const [url, setUrl] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const fetchSignedURL = async () => {
            setUrl('')
            setIsLoading(true)

            if (!src || src.trim().length === 0) {
                setIsLoading(false)
                return
            }

            const signedUrl = await getSignedURLSByPath(src.trim())
            if (signedUrl.length === 0) {
                setIsLoading(false)
            }
            setUrl(signedUrl)
        }

        fetchSignedURL()
    }, [src])

    return { url, isLoading }
}
